export default "__VITE_ASSET__2HuYEcNI__"